<script>
// import SuppliersApi from "@/services/suppliers-api";
import CustomersApi from "@/services/customers-api";
import OrdersApi from "@/services/orders-api";
import simplebar from "simplebar-vue";

export default {
    components: {
        simplebar
    },
    mounted(){
        this.getTotalSalesPerCustomerAndSupplier();
        this.getSuppliers();
        this.getCustomers();
        this.getTotalsales()
        this.start=this.firstDay
        this.end=this.lastDay  
    },

        props: {
          isCurrentMonthProp:{
              type :Boolean,
              default:false
          },
          isCurrentMonthProp2:{
              type :Boolean,
              default:false
          },
          firstDay:{
              type:String,
              default:null
          },
          lastDay:{
              type:String,
              default:null
          },
          isListPerCustomer:{
            type:Boolean,
            default:false
          },
          isListPerSupplier:{
            type:Boolean,
            default:false
          },

    },
   
    data () {
        return {
            grid:[],
            customersList:[],
            suppliersList:[],
            selectedSupplier:null,
            selectedCustomer:null,
            selected:null,
            selected1:null,
            start:this.firstDay,
            end:this.lastDay,
            isCurrentMonth:this.isCurrentMonthProp,
            isCurrentMonth2:this.isCurrentMonthProp2,
            isTableLoading:false,
            total:null,
            forceRenderSimpleBar:false,
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},

            }
            
    },
    methods: {
    getTotalSalesPerCustomerAndSupplier(){
      this.isTableLoading=true
            OrdersApi.getTotalSalesPerCustomerAndSupplier(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer,this.selectedSupplier,this.isCurrentMonth,this.isListPerCustomer,this.isListPerSupplier).then(
            (result)=>{
                if(result){
                    this.grid=result.list;
                    this.pagemodel.totalRows = result.total;
                    this.pagemodel.currentPage = result.page;
                    this.pagemodel.perPage = result.pageSize;
                    this.pagemodel.pageSize = result.pageSize;
                    this.isCurrentMonth=false
                    this.forceRenderSimpleBar = true;

                }  
            }
        ).finally(()=>{
                this.isTableLoading=false
                this.isCurrentMonth=false
                this.forceRenderSimpleBar = true;
            })

      }, 

    getTotalsales(){
      /*OrdersApi.getTotalSales(this.start,this.end,this.isCurrentMonth2).then(
        (result)=>{
          if(result){
            this.total=result
            this.isCurrentMonth2=false
          }
        }
      )*/
    },

    getSuppliers(){
      /*SuppliersApi.getAllSuppliers().then(
        response => {
          this.suppliersList=response;
        }
      )*/
    },

    getCustomers(){
      CustomersApi.getCustomers().then(
        response => {
          this.customersList=response;
        }
      )
    },

    },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
            this.getTotalSalesPerCustomerAndSupplier()
        },
        selected1: function() {
            this.selectedSupplier = this.selected1 ? this.selected1.id : null
            this.getTotalSalesPerCustomerAndSupplier()
        },
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getTotalSalesPerCustomerAndSupplier()
            this.getTotalsales()

          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getTotalSalesPerCustomerAndSupplier()
            this.getTotalsales()

          }
        },
        
    }

};
</script>
<template>
<div class=" mt-2 mb-2  h-100" :class="isListPerCustomer ? 'mr-lg-2' :'ml-lg-2' " >
    <div class=" p-0">
        <div class="clearfix m-4">
            <div class="float-right ">
            <div class="input-group input-group-sm">

            </div>
            </div>
            <h4 v-if="isListPerCustomer" class="card-title mb-2 font-size-18 text-dark">Volume des achats par Client</h4>
            <h4 v-if="isListPerSupplier" class="card-title mb-2 font-size-18 text-dark">Volume des achats par fournisseur</h4>

              <div class="row pt-3">
                <div class="col-md-12 pr-2 pt-2 pt-md-0">
                   <!-- <b-form-group label="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Clients" label="name" v-model="selected">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group> -->



                  <b-form-group label="" label-for="">
                    <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>


                </div>
                 <!-- <div class="col-md-6 pr-2 pt-2 pt-md-0">
                    <b-form-group label="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseurs" label="name" v-model="selected1">
                        <span slot="no-options">Aucun Fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                </div> -->
              </div>
              <div class="row">
                    <div class="col-md-6  pr-2">

                      <b-form-group >
                        <b-form-datepicker
                          v-model="start"
                          locale="fr"
                          label-no-date-selected="Date Début"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 pr-2">
                      <b-form-group  >
                        <b-form-datepicker
                          v-model="end"
                          locale="fr"
                          label-no-date-selected="Date Fin"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright                         
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                      
                    </div> 
              
              
                    
              </div>
        </div>
            <div class="table-responsive mt-4" >
                <simplebar v-if="forceRenderSimpleBar" style="min-height:23em;max-height:23em" >
                    <table class="table table-centered" >
                        <tbody>
                            <tr v-for="data in grid" :key="data.customerName" >
                                <td v-if="isListPerCustomer" class=" pl-sm-4 ">
                                  <h5 class="font-size-16 font-weight-bold mb-1">{{data.customerName}}</h5>
                                </td>
                                <td  v-if="isListPerSupplier" class=" pl-sm-4 ">
                                  <img class="d-none d-sm-inline-block" v-bind:src="'/api/image/get/' + data.supplierLogo" alt style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px; " >
                                </td>
                                <td v-if="isListPerSupplier" >
                                  <h5 class="font-size-16 font-weight-bold mb-1">{{data.supplierName}}</h5>
                                </td>
                                <td style="width: 16em" >
                                    <h5 class="mb-0">{{data.sumAsString}}</h5>
                                </td>
                                <td v-if="total!=null && total!=0 && data.sum!=0" style="width: 14em" >
                                    <b-progress 
                                    :value="data.sum/total * 100" 
                                    variant="success" 
                                    height="15px" 
                                    show-value>
                                    </b-progress>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </simplebar >
                <div v-if="isTableLoading" class="d-flex justify-content-center">
                  <div class="spinner-border text-success" role="status">
                    <span class=" sr-only">Loading...</span>
                  </div>
                </div>
                <span v-if="!isTableLoading & !grid.length" class="d-flex justify-content-center m-4 text-danger" >Aucune ligne dans le tableau </span>
            </div>
          <!-- Pagination -->
        <div class="row pt-3 pl-2 " >
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTotalSalesPerCustomerAndSupplier();getTotalsales()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur </span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getTotalSalesPerCustomerAndSupplier();getTotalsales()" :disabled="isTableLoading" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        </div>
    </div>
</template>
